import { useUserPlanContext } from '@/finsight/application/User/UserPlan/UserPlanContext';
import { usePageFiltersContext } from '@/finsight/application/PageFilters/PageFiltersContext';
import { UserPlanType } from '@/users/domain/UserPlan';

export const useDealAccess = () => {
  const { checkAccessByUserPlan } = useUserPlanContext();
  const {
    checkAccessByUserRegions,
    checkAccessByUserProducts,
    company,
    pageFilters: { profileType },
  } = usePageFiltersContext();

  let userAccessChecks = [checkAccessByUserPlan(UserPlanType.PREMIUM)];

  if (profileType || company) {
    userAccessChecks = [
      ...userAccessChecks,
      checkAccessByUserRegions(),
      checkAccessByUserProducts(),
    ];
  }

  return {
    userAccessChecks,
    hasAccess: userAccessChecks.every(Boolean),
  };
};
